import { Fragment } from "react";
import { Link } from "react-router-dom";

const TOKEN = /(\*\*[^*]+\*\*|\/(?:register(?:\?[^\s)]*)?|track(?:\/ET-[A-Z0-9]{6})?|faq|services|how-it-works|contact)(?![\w-]))/g;

const Inline = ({ text, onNavigate }) => (
  <>
    {text.split(TOKEN).map((part, i) => {
      if (!part) return null;
      if (part.startsWith("**")) return <strong key={i} className="font-semibold text-slate-900">{part.slice(2, -2)}</strong>;
      if (part.startsWith("/")) return <Link key={i} to={part} onClick={onNavigate} className="text-brand-600 underline underline-offset-2">{part}</Link>;
      return <Fragment key={i}>{part}</Fragment>;
    })}
  </>
);

export const RichText = ({ text, onNavigate }) => (
  <div className="space-y-2">
    {text.split(/\n{2,}/).map((block, i) => {
      const lines = block.split("\n").filter(Boolean);
      if (lines.length && lines.every((l) => /^\s*[-•]\s+/.test(l))) {
        return (
          <ul key={i} className="list-disc pl-4 space-y-1">
            {lines.map((l, j) => <li key={j}><Inline text={l.replace(/^\s*[-•]\s+/, "")} onNavigate={onNavigate} /></li>)}
          </ul>
        );
      }
      return <p key={i}>{lines.map((l, j) => <Fragment key={j}>{j > 0 && <br />}<Inline text={l.replace(/^\s*[-•]\s+/, "• ")} onNavigate={onNavigate} /></Fragment>)}</p>;
    })}
  </div>
);
